import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';

/**
 * Languages offered in the switcher. Adding one here (plus its resource
 * bundle below) is all that's needed — the switcher renders from this list.
 *
 * Hindi was removed from the offer; `locales/hi.json` is still on disk, so
 * restoring it means re-adding its import, this entry and the code to
 * `resources` / `supportedLngs`.
 */
export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English', native: 'English' },
];

const STORAGE_KEY = 'app_language';

const readStoredLanguage = () => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    // Storage blocked (private mode); detection falls back to the navigator.
    return null;
  }
};

// A language that is no longer offered can still be sitting in localStorage
// from an earlier visit. Clear it so those users land on English instead of a
// language the switcher can no longer show.
const stored = readStoredLanguage();
if (stored && !SUPPORTED_LANGUAGES.some((l) => stored.startsWith(l.code))) {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Nothing to clear if storage is unavailable.
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: STORAGE_KEY,
      caches: ['localStorage'],
    },
  });

export default i18n;
